document.addEventListener('DOMContentLoaded', () => {
  // watch video
  document.querySelectorAll('.video [data-video-btn]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const isHosted = el.getAttribute('data-hosted') === 'true' ?? false;
      el.nextElementSibling.hidden = false;
      if (isHosted) {
        el.nextElementSibling.play();
      } else {
        el.nextElementSibling.removeAttribute('srcdoc');
      }
      if (el.querySelector('.video__play')) {
        el.querySelector('.video__play').remove();
      }
      el.closest('.video').classList.add('video--is-playing');
      return false;
    });
  });
});
